const basePath = import.meta.env.VITE_BASE_PATH ?? "/";

export const base_path = basePath;
export const image_path = basePath;
